module.exports = __webpack_public_path__ + "0bb078acf6ee54efd563b94a00f70f97.pdf";